// extracted by mini-css-extract-plugin
export default {"passedIcon":"PassedIcon_passedIcon__EloX6"};